import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { OperationalCostReimbursementService } from '../../service/operational-cost-reimbursement.service';
import * as OcrActions from './operational-cost-reimbursement.action';
import { OcrActionTypes } from './operational-cost-reimbursement.action';
import {
  IOcrClaimSubmissionResult,
  IOcrEligibility,
} from '../../domain/operational-cost-reimbursement.model';
import { httpFaultMessage } from '../../../shared/utils/http-fault.util';

@Injectable()
export class OcrEffect {
  getEligibility$ = createEffect(() =>
    this.actions$.pipe(
      ofType<OcrActions.GetEligibility>(OcrActionTypes.GetEligibility),
      exhaustMap(() =>
        this.ocrService.getEligibility().pipe(
          map(
            (data: IOcrEligibility) =>
              new OcrActions.GetEligibilitySuccess(data),
          ),
          catchError((err: HttpErrorResponse) =>
            of(new OcrActions.GetEligibilityFault(httpFaultMessage(err))),
          ),
        ),
      ),
    ),
  );

  submitClaim$ = createEffect(() =>
    this.actions$.pipe(
      ofType<OcrActions.SubmitClaim>(OcrActionTypes.SubmitClaim),
      exhaustMap((action) =>
        this.ocrService.submitClaim(action.payload).pipe(
          map(
            (data: IOcrClaimSubmissionResult) =>
              new OcrActions.SubmitClaimSuccess(data),
          ),
          catchError((err: HttpErrorResponse) =>
            of(new OcrActions.SubmitClaimFault(httpFaultMessage(err))),
          ),
        ),
      ),
    ),
  );

  // BRD FR-5.1 (Slice 4, BRD §21) — Verify & Submit, Month 2 onward.
  verifySubmitClaim$ = createEffect(() =>
    this.actions$.pipe(
      ofType<OcrActions.VerifySubmitClaim>(OcrActionTypes.VerifySubmitClaim),
      exhaustMap((action) =>
        this.ocrService
          .verifySubmitClaim(action.monthIndex, action.payload)
          .pipe(
            map(
              (data: IOcrClaimSubmissionResult) =>
                new OcrActions.VerifySubmitClaimSuccess(data),
            ),
            catchError((err: HttpErrorResponse) =>
              of(new OcrActions.VerifySubmitClaimFault(httpFaultMessage(err))),
            ),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private ocrService: OperationalCostReimbursementService,
  ) {}
}
